module.exports = __webpack_public_path__ + "assets/img/arezzoco-branco.ac0f64be.png";